import { useState, useEffect } from 'react';

export const useDarkMode = () => {
  // Check localStorage for saved theme preference, default to false (light mode)
  const [isDarkMode, setIsDarkMode] = useState(() => {
    const savedTheme = localStorage.getItem('darkMode');
    return savedTheme === 'true';
  });

  useEffect(() => {
    // Save theme preference to localStorage
    localStorage.setItem('darkMode', isDarkMode.toString());
    
    // Apply theme to document root
    if (isDarkMode) {
      document.documentElement.classList.add('dark-theme');
    } else {
      document.documentElement.classList.remove('dark-theme');
    }
  }, [isDarkMode]);

  const toggleDarkMode = () => {
    setIsDarkMode(prev => !prev);
  };

  return { isDarkMode, toggleDarkMode };
};
